'use client';

import { Card } from '../ui/Card';
import { Brain, Clock, Mic, AlertCircle, MapPin, Users, Handshake, Shield, Bell } from 'lucide-react';
import { useTranslations } from 'next-intl';

export function Features() {
  const t = useTranslations('home.features');
  
  const earitFeatures = [
    {
      icon: Brain,
      key: 'aiDetection',
      color: 'bg-purple'
    },
    {
      icon: Clock,
      key: 'background',
      color: 'bg-navy'
    },
    {
      icon: Mic,
      key: 'recording',
      color: 'bg-turquoise'
    }
  ];

  const safetizenFeatures = [
    {
      icon: AlertCircle,
      key: 'instantSos',
      color: 'bg-raspberry'
    },
    {
      icon: MapPin,
      key: 'realTimeGeo',
      color: 'bg-turquoise'
    },
    {
      icon: Users,
      key: 'trustedContacts',
      color: 'bg-navy'
    },
    {
      icon: Handshake,
      key: 'inclusiveCommunity',
      color: 'bg-purple'
    },
    {
      icon: Shield,
      key: 'passiveProtection',
      color: 'bg-navy'
    },
    {
      icon: Bell,
      key: 'citizenInnovation',
      color: 'bg-turquoise'
    }
  ];

  return (
    <>
      <section className="py-20 px-4 bg-section-turquoise-light">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-16 text-navy">
            {t('title')}
          </h2>
          <h3 className="text-3xl font-bold text-center mb-12 text-navy">
            {t('safetizen.title')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {safetizenFeatures.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <Card key={index} hover>
                  <div
                    className={`w-12 h-12 rounded-lg ${feature.color} flex items-center justify-center mb-4 shadow-lg`}
                  >
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <h4 className="text-xl font-semibold text-foreground mb-2">
                    {t(`safetizen.items.${feature.key}.title`)}
                  </h4>
                  <p className="text-foreground leading-relaxed">
                    {t(`safetizen.items.${feature.key}.description`)}
                  </p>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-20 px-4 bg-section-purple-light">
        <div className="max-w-7xl mx-auto">
          <h3 className="text-3xl font-bold text-center mb-12 text-navy">
            {t('earit.title')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {earitFeatures.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <Card key={index} hover>
                  <div
                    className={`w-12 h-12 rounded-lg ${feature.color} flex items-center justify-center mb-4 shadow-lg`}
                  >
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <h4 className="text-xl font-semibold text-foreground mb-2">
                    {t(`earit.items.${feature.key}.title`)}
                  </h4>
                  <p className="text-foreground leading-relaxed">
                    {t(`earit.items.${feature.key}.description`)}
                  </p>
                </Card>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
